<template>
  <th :class="['sort-table-header', sortClass, wrapperClasses]"
      :aria-controls="ariaControlId"
      @click="sort">
    <span>{{text}}</span>
  </th>
</template>

<script>
  export default {
    props: {
      ariaControlId: String,
      defaultSort: String,
      sortId: String,
      text: String,
      wrapperClasses: String
    },
    name: "SortTableHeader",
    methods: {
      sort() {
        this.$emit("sortLocation", this.sortId)
      }
    },
    computed: {
      sortClass() {
        return this.defaultSort ? this.defaultSort === "asc" ? "sorting_asc" : "sorting_desc" : "sorting"
      }
    }
  }
</script>